const matchUrl = (stringData) => {
    const rule = /\[(.*?)\]/;
    return stringData.match(rule);
} 

export default matchUrl;